import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import useToast from '../../../hooks/useToast';
import LoaderContext from '../../../context/LoaderProvider';
import useLocationProgramPoints from '../ProgramPointModal/useLocationProgramPoints';

const ApproveAllModal = ({ show, onHide, onAccept, allIds }) => {
  const { setNewToast } = useToast();
  const [disableButton, setDisableButton] = useState(false);
  const { setLoader } = useContext(LoaderContext);

  const { approveAll } = useLocationProgramPoints({
    line: null
  });

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={async () => {
        try {
          setDisableButton(true);
          setLoader(true);

          await approveAll(allIds);

          onHide();

          onAccept();
        } catch (err) {
          setNewToast({
            type: 'ERROR',
            message: err.message
          });
        } finally {
          setLoader(false);
          setDisableButton(false);
        }
      }}
      primaryActionDisabled={disableButton}
      primaryActionLabel="Aceptar"
      secondaryAction={onHide}
      secondaryActionLabel="Salir"
      show={show}
      title="Aprobar todo"
      variantHeader="warning"
    >
      <p className="fw-bold text-center">
        Estás por aprobar todos los elementos pendientes que estás visualizando
      </p>
    </ModalGeneric>
  );
};

export default ApproveAllModal;

ApproveAllModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  allIds: PropTypes.arrayOf(PropTypes.number)
};

ApproveAllModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  allIds: []
};
